import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';

export const DEFAULT_QUICK_AMOUNTS = [10, 30, 50, 60, 1000, 3000];

export function resolveImageUrl(image) {
  return resolveMemberMediaUrl(image);
}

/** 解析多語系標題 JSON 或純文字顯示名稱 */
export function resolveLocalizedDisplayName(value, locale = 'en_US') {
  if (value == null || value === '') {
    return '';
  }
  const text = String(value).trim();
  if (!text.startsWith('[')) {
    return text;
  }
  try {
    const list = JSON.parse(text);
    if (!Array.isArray(list) || list.length === 0) {
      return text;
    }
    const normalizedLocale = locale === 'zh_HK' ? 'zh_TW' : locale;
    const matched = list.find(
      (item) => String(item?.lang || '').toLowerCase() === String(normalizedLocale).toLowerCase()
        && item?.title
    );
    if (matched?.title) {
      return String(matched.title).trim();
    }
    const english = list.find(
      (item) => String(item?.lang || '').toLowerCase() === 'en_us' && item?.title
    );
    if (english?.title) {
      return String(english.title).trim();
    }
    const first = list.find((item) => item?.title);
    return first?.title ? String(first.title).trim() : text;
  } catch {
    return text;
  }
}

export function buildQrCodeUrl(value, size = 200) {
  if (!value) {
    return '';
  }
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`;
}

export function formatDepositAmount(value, digits = 4) {
  if (value == null || value === '') {
    return (0).toFixed(digits);
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toFixed(digits);
}

export function formatAmountRange(min, max) {
  const minValue = Number(min);
  const maxValue = Number(max);
  if (!Number.isNaN(minValue) && !Number.isNaN(maxValue) && minValue > 0 && maxValue > 0) {
    return `${minValue} ~ ${maxValue.toLocaleString()}`;
  }
  if (!Number.isNaN(minValue) && minValue > 0) {
    return `≥ ${minValue}`;
  }
  if (!Number.isNaN(maxValue) && maxValue > 0) {
    return `≤ ${maxValue.toLocaleString()}`;
  }
  return '—';
}

export function isAmountInRange(amount, min, max) {
  const value = Number(amount);
  if (Number.isNaN(value) || value <= 0) {
    return false;
  }
  const minValue = Number(min);
  const maxValue = Number(max);
  if (!Number.isNaN(minValue) && minValue > 0 && value < minValue) {
    return false;
  }
  if (!Number.isNaN(maxValue) && maxValue > 0 && value > maxValue) {
    return false;
  }
  return true;
}

export function calcRebateAmount(amount, rebatePercent) {
  const value = Number(amount);
  const rate = Number(rebatePercent);
  if (Number.isNaN(value) || Number.isNaN(rate) || rate <= 0) {
    return 0;
  }
  return (value * rate) / 100;
}

export async function copyText(text) {
  if (!text) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
